'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import Login from './login';

function LoginWrapper() {
  const searchParams = useSearchParams();
  const from = searchParams.get('from');
  const expired = searchParams.get('expired') === 'true';
  const revoked = searchParams.get('revoked') === 'true';

  return <Login searchParams={{ from, expired, revoked }} />;
}

const AuthLogin = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <LoginWrapper />
  </Suspense>
);

export default AuthLogin;
